<template>
  <v-app>
    <v-main>
      <app-error-messages />
      <v-app-bar
        color="white"
        @click="drawer = !drawer"
      >
        <v-container class="d-flex align-center mx-auto ga-5">
          <v-img
            max-height="38"
            max-width="117"
            src="@/images/logo.svg"
          />
          <template v-if="$vuetify.display.mdAndUp">
            <div

              class="d-flex"
            >
              <v-btn
                v-for="link in links"
                :key="link.text"
                :active="false"
                :text="link.text"
                :to="link.to"
                variant="text"
              />
            </div>
            <v-spacer />
            <v-btn-secondary
              :to="$routeTo(ROUTES.LOGIN)"
              border="0"
              variant="text"
            >
              {{ $auth.user ? 'Dashboard' : 'Log In' }}
            </v-btn-secondary>
            <v-btn-primary
              :to="$routeTo(ROUTES.REGISTER)"
            >
              Sign Up
            </v-btn-primary>
          </template>
        </v-container>
        <v-app-bar-nav-icon v-if="$vuetify.display.smAndDown" />
      </v-app-bar>
      <v-navigation-drawer
        v-if="$vuetify.display.smAndDown"
        v-model="drawer"
        location="right"
        width="300"
      >
        <template #append>
          <v-row
            align="start"
            justify="center"
            no-gutters
            class="mb-4"
          >
            <v-col
              cols="6"
            >
              <v-btn-secondary
                :to="$routeTo(ROUTES.LOGIN)"
                block
                border="0"
                variant="text"
              >
                {{ $auth.user ? 'Dashboard' : 'Log In' }}
              </v-btn-secondary>
            </v-col>
            <v-spacer />
            <v-col
              cols="6"
            >
              <v-btn-primary
                :to="$routeTo(ROUTES.REGISTER)"
              >
                Sign Up
              </v-btn-primary>
            </v-col>
          </v-row>
        </template>
        <div class="mt-4">
          <v-btn
            v-for="link in links"
            :key="link.text"
            block
            :active="false"
            :text="link.text"
            :to="link.to"
            variant="text"
          />
        </div>
      </v-navigation-drawer>
      <v-slide-x-reverse-transition mode="out-in">
        <span class="transition-wrapper">
          <slot />
        </span>
      </v-slide-x-reverse-transition>
      <v-footer color="primary">
        <v-container>
          <v-divider
            class="mb-8"
            color="white"
          />
          <div class="d-flex justify-space-between align-center flex-md-row-reverse flex-wrap">
            <div>
              <v-btn
                :to="$routeTo(ROUTES.TERMS_OF_SERVICE)"
                color="white"
                variant="text"
              >
                Terms
              </v-btn>
              <v-btn
                :to="$routeTo(ROUTES.PRIVACY_POLICY)"
                color="white"
                variant="text"
              >
                Privacy
              </v-btn>
              <v-btn
                :to="$routeTo(ROUTES.COOKIE_POLICY)"
                color="white"
                variant="text"
              >
                Cookies
              </v-btn>
            </div>
            <div class="pl-5 pl-md-0">
              © {{ new Date().getFullYear() }} Our Last Words. All rights reserved.
            </div>
          </div>
        </v-container>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import AppErrorMessages from "@/components/AppErrorMessages.vue"

export default defineComponent({
  components: {AppErrorMessages},
  data() {
    return {
      drawer: false as boolean,
      isDev: import.meta.env.VITE_APP_ENV === "dev" || import.meta.env.VITE_APP_ENV === "local",
      links: [
        {text: 'Home', to: '/#hero'},
        {text: 'How It Works', to: '/#works'},
        {text: 'Pricing', to: '/#pricing'},
        {text: 'Contact', to: '/#contact'},
      ]
    }
  },
})
</script>

<style scoped></style>
